<template>
  <div
    class="wrapper row no-margin"
    style="height: 100%;display: flow-root;">

    <header class="row align-items-center no-margin">
      <div class="col">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')">
          <i class="fas fa-times"/>
        </button>
      </div>
    </header>

    <div class="col-12 mt-3 mb-1 status">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          {{ $t('message.availabletables') }} ({{ availableTablesCount }})
        </div>
        <div class="text-right">
          <BaseButton
            className="btn-light"
            style="position: relative;top: -7px;"
            @click="handleClickMoveTable"
          >
            <i class="fas fa-exchange-alt"/>
            {{ $t('apps.pos.button.movetable', { ref_name: refName }) }}
          </BaseButton>
        </div>
      </div>
    </div>
    <ul class="col-12 no-padding items">
      <li
        v-if="table_number"
        :class="[
          {'disabled': hasDisabledTable}
        ]"
        class="row no-margin item text-danger"
        @click="onStandBy()">
        <div class="col">
          <i
            class="fas fa-ban"
            style="margin-right: 7px;margin-left: 3px;font-size: 13px;"/>
          {{ $t('message.deselected') }}
        </div>
      </li>
      <li
        v-for="(table, index) in mapTables"
        :key="index"
        :class="[...table.classNames]"
        class="row no-margin item"
        @click="onSelectedTable(table.table_number)"
      >
        <div class="col">
          <span>
            <i
              v-if="table.table_number == table_number"
              class="fas fa-arrow-right"/>
            <i class="fas fa-circle"/>
            {{ $t('apps.pos.message.tablenumber', {ref_name: refName, number: table.table_number}) }}
          </span>

          <span
            v-if="isTaken(table.table_number) && isRenderTime"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{
              getDiffTime(table.start_at, {
                hours: $t('message.hours'),
                minutes: $t('message.minutes'),
                seconds: $t('message.seconds')
              })
            }}
          </span>

          <span
            v-if="table.queue_number"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ $t('apps.pos.message.queuenumber', { number: table.queue_number }) }}
          </span>

          <span
            v-if="table.orderCount"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ $t('apps.pos.message.orderinqueuecount', { number: table.orderCount }) }}
          </span>

          <span
            v-if="table.diningName"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ table.diningName }}
          </span>
          <span
            v-if="table.customerName"
            class="badge badge-secondary"
            style="position: relative;top: -1px;">
            {{ table.customerName }}
          </span>
        </div>
      </li>
    </ul>

    <b-modal
      :id="`modal-confirm-move-table`"
      :title="moveOrderModalTitle"
      :hideHeaderClose="true"
      size="md"
      noFade
      noCloseOnBackdrop
    >
      <div>
        <div class="form-row">
          <div class="col-6">
            {{ $t('apps.pos.message.movetablefrom') }}
            <select
              v-if="table_number != null"
              v-model="moveFromTableNumber"
              class="form-control form-control-sm custom-select"
            >
              <option :value="null">{{ $t('placeholder.select') }}</option>
              <option
                v-for="(table, index) in moveFromTableOptions"
                :key="index"
                :value="table.value">
                {{ table.text }}
              </option>
            </select>
            <div v-else>
              <select
                :disabled="true"
                class="form-control form-control-sm custom-select"
              >
                <option>{{ $t('message.notselectedtable') }}</option>
              </select>
            </div>
          </div>
          <div class="col-6">
            {{ $t('apps.pos.message.movetableto') }}
            <select
              v-model="moveToTableNumber"
              class="form-control form-control-sm custom-select">
              <option :value="null">{{ $t('placeholder.select') }}</option>
              <option
                v-for="(table, index) in moveToTableOptions"
                :key="index"
                :value="table.value">
                {{ table.text }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="moveToTableNumber"
          class="row mt-3">
          <div class="col-12">
            {{ $t('apps.pos.message.moveorderlists') }} ({{ moveOrders.length }})
          </div>
          <div class="col-12">
            <ul class="mb-0">
              <li
                v-for="(order, index) in moveOrders"
                :key="index"
                style="list-style: disc;margin-left: 15px;">
                {{ order.item }} x{{ order.quantity }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok}">
        <div
          class="d-flex justify-content-end w-100"
          style="gap: 10px;"
        >
          <BaseButton
            :text="$t('button.cancel')"
            className="btn-sm btn-light"
            @click="handleCloseMoveTable(ok)"/>
          <BaseButton
            :text="$t('button.confirm')"
            :disabled="!moveToTableNumber || moveOrders.length == 0 || (table_number != null && moveFromTableNumber == null)"
            className="btn-sm btn-web"
            @click="handleConfirmMoveTable(ok)"/>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import tableListMixin from '@/mixins/pos/tableList'

export default {
  mixins: [tableListMixin],
}
</script>

<style scoped>
  .wrapper ul.items {
    overflow: auto;
  }
  .wrapper ul.items li.item {
    padding: 10px 15px;
    background: #fff;
    border-bottom: solid 1px #F2F2F2;
    cursor: pointer;
  }
  .wrapper ul.items li.item.active {
    background: #f8f9fa;
  }
  .wrapper ul.items li.item .col {
    padding: 0;
  }
  .wrapper ul.items li.item i.fa-circle {
    font-size: 8px;
    position: relative;
    top: -2px;
    margin-right: 12px;
    margin-left: 6px;
    color: #FF9800;
  }
  .wrapper ul.items li.item.available i.fa-circle {
    color: #8BC34A;
  }
  ul.items li.disabled {
    pointer-events: none;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/TableList.vue